<template>
  <table>
    <tr>
      <template v-for="subject in subjects" >
        <th :key="subject.code" v-if="!hideSubjectCodes.includes(subject.code)">
          <v-checkbox
            class="ma-0 mt-1"
            style="display: inline-block;"
            v-model="allChecked"
            hide-details=""
            :value="subject.code"
            dark
            @click="allCheck(subject.code)"
          >
            <template v-slot:label>
              <p class="ma-0 pa-0 checkbox__label">{{subject.name}}全
                <template v-if="subject.code === 'sh'">
                  <br><span style="font-size: 11px !important">（地理・歴史・公民）</span>
                </template>
              </p>
            </template>
          </v-checkbox>
        </th>
      </template>
    </tr>
    <tr v-for="grade in grades" :key="grade.code">
      <template v-for="subject in subjects">
        <td
          v-if="!hideSubjectCodes.includes(subject.code) && !(grade.code === 'ssk' && !['ko', 'su', 'ei', 'ri', 'sh'].includes(subject.code))"
          :key="subject.code+grade.code"
          :class="getTdClass(subject.code, grade.code)"
          @click="clickTd(subject.code, grade.code)"
        >
          {{grade.code === 'ssk' ? `${grade.name}(${subject.name})` : subject.name + grade.name}}
          <template v-if="subject.code === 'sh'">
            <br><span style="font-size: 12px !important">（地理・歴史・公民）</span>
          </template>
        </td>
      </template>
    </tr>
  </table>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    hideSubjectCodes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    allChecked: [],
  }),

  mounted() {
  },

  computed: {
    // 【担当教科】 編集の場合は保持した値をセット
    selected: {
      get() {
        // オブジェクトから配列に変換(storeに格納するとなぜかオブジェクトになる？)
        let selected = this.$store.state.account.selectedSubjects
        return Object.keys(selected).map(key => selected[key])
      },
      set(payload) {
        // 教科選択状態をstoreに格納
        // 配列のまま格納できないのでオブジェクトに変換する ["ko1", "ei2", "su2"] => {0:"ko1", 1:"ei2", 2:"su2"};
        const selectedSubjects = Object.assign({}, payload);
        this.$store.commit("account/setSelectedSubjects", {
          selectedSubjects: selectedSubjects
        })
      }
    },
    grades() {
      const grades = cloneDeep(this.$store.state.master.allGrades)
      grades.push({code: 'ssk', name: '新研究'})
      return grades
    },
    subjects() {
      return this.$store.state.master.allSubjects.filter(item => item.ancestryDepth == 0) // 階層が０のもののみ使用する（地歴公民も表示されるので）
    }
  },

  methods: {
    getTdClass(subjectCode, gradeCode) {
      const code = subjectCode+gradeCode;
      return {
        'td__shakai': subjectCode === 'sh',
        'selected': this.selected.includes(code),
      }
    },

    allCheck(subjectCode) {
      const func = this.allChecked.includes(subjectCode) ? this.add : this.remove;
      this.grades.forEach(grade => {
        this.selected = func(this.selected, subjectCode+grade.code)
      })
    },

    clickTd(subjectCode, gradeCode) {
      const code = subjectCode+gradeCode;
      const func = this.selected.indexOf(code) == -1 ? this.add : this.remove;
      this.selected = func(this.selected, code)
      this.confirmAllCheck(subjectCode)
    },

    // 全チェック入れる外すのチェック
    confirmAllCheck(subjectCode) {
      const subject = this.subjects.find(subject => subject.code === subjectCode);
      const selectedCount = this.selected.filter(select => select.includes(subject.code)).length
      const func = selectedCount === 3 ? this.add : this.remove
      this.allChecked = func(this.allChecked, subjectCode)
    },

    add(array, code) {
      array.push(code)
      // 重複は除去して返す
      return [...new Set(array)]
    },

    remove(array, code) {
      const targetIndex = array.indexOf(code);
      if (targetIndex != -1) array.splice(targetIndex, 1);
      return array
    },
  }
}
</script>

<style lang="stylus" scoped>
th
  width 150px
  height 30px
  background-color #6e6e6e

td
  text-align center
  border 1px solid #dddd
  font-size 14px !important
  height 50px
  transition background-color .3s, transform 0.3s
  cursor pointer

.td__shakai
  font-size: 13px !important;

.checkbox__label
  color white !important
  font-size 14px !important

.selected
  color #fff
  font-weight bold
  background-color #f67a06
</style>
